import "./header.scss";
import { useState } from "react";
import { useAuth, logout } from "../../services/auth";
import logoutIcon from "../../assets/logout.svg";
import leaderboard from "../../assets/leaderboard.svg";
import questionMark from "../../assets/question-mark.svg";
import { useNavigate } from "react-router-dom";
import { userViewLeaderboard } from "../../services/events";
import { useTheme } from "../../services/theme";
import InfoModal from "../info-modal/info-modal";

const Header = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const { theme, toggleTheme } = useTheme();
    const [showInfo, setShowInfo] = useState(false);

    const navigateToLeaderboard = () => {
        userViewLeaderboard();
        navigate("/leaderboard");
    };

    const logoutGame = () => {
        logout().then(() => navigate("/"));
    };

    return (
        <>
            <header id="header">
                <div className="header-left">
                    <button
                        className="theme-toggle"
                        onClick={toggleTheme}
                        title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
                    >
                        {theme === "light" ? (
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                            </svg>
                        ) : (
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="5"/>
                                <line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/>
                                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                                <line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/>
                                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                            </svg>
                        )}
                    </button>
                </div>
                <h1 onClick={() => navigate("/")} className="logo">Flip A Coin</h1>
                <menu>
                    <button onClick={() => setShowInfo(true)}>
                        <img src={questionMark} alt="help" className="help" />
                    </button>
                    <button onClick={navigateToLeaderboard}>
                        <img
                            src={leaderboard}
                            alt="leaderboard"
                            className="leaderboard"
                        />
                    </button>
                    {user ? (
                        <button onClick={logoutGame}>
                            <img
                                src={logoutIcon}
                                alt="logout"
                                className="logout"
                            />
                        </button>
                    ) : (
                        <button className="login-btn" onClick={() => navigate("/login")}>
                            Sign In
                        </button>
                    )}
                </menu>
            </header>
            <InfoModal isOpen={showInfo} onClose={() => setShowInfo(false)} />
        </>
    );
};

export default Header;
